module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": 'Sites for ' + _vm.category,
      "titleClass": "text-info",
      "table-ref": "orgSitesTable",
      "url": '/org/sites/' + Number(this.org_id),
      "fields": _vm.fields,
      "show-search": false,
      "add-action": _vm.action,
      "add-props": _vm.addProps,
      "sort-field": "site.siteName"
    },
    scopedSlots: _vm._u([{
      key: "info",
      fn: function(props) {
        return [_c('popup', {
          attrs: {
            "show-text": false,
            "button-text": "",
            "heading": props.rowData.site.siteName,
            "button-icon": "fa fa-info",
            "button-style": "primary",
            "show-save": false
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('site-card', {
          attrs: {
            "site-data": props.rowData.site
          }
        })], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('site-info', {
          attrs: {
            "row-data": props.rowData.site
          }
        })], 1)], 1)], 1)]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [(_vm.isManager()) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "fa fa-trash",
            "circle": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteSite(props.rowData)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-583811f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/OrgSitesTable.vue
// module id = 1578
// module chunks = 0